import { Injectable, inject, signal, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export interface GetSystemTimeResponse {
    serverTime: string;
}

@Injectable({
    providedIn: 'root'
})
export class SystemTimeService implements OnDestroy {
    private http = inject(HttpClient);
    private readonly baseUrl = environment.apiUrl + '/api/System';

    currentTime = signal(new Date());
    private serverOffset = 0;
    private timerId: any;

    constructor() {
        this.init();
    }

    private init() {
        this.syncTime();
        this.startTimer();
    }

    syncTime() {
        this.http.get<GetSystemTimeResponse>(`${this.baseUrl}/Time`).subscribe({
            next: (res) => {
                const serverDate = new Date(res.serverTime);
                const localDate = new Date();
                this.serverOffset = serverDate.getTime() - localDate.getTime();
                this.updateCurrentTime();
            },
            error: (err) => {
                console.error('Failed to sync system time', err);
            }
        });
    }

    private startTimer() {
        this.timerId = setInterval(() => {
            this.updateCurrentTime();
        }, 1000);
    }

    private updateCurrentTime() {
        const now = new Date();
        this.currentTime.set(new Date(now.getTime() + this.serverOffset));
    }

    ngOnDestroy() {
        if (this.timerId) {
            clearInterval(this.timerId);
        }
    }
}

